import { Deserializable } from '../protocols/deserializable';
import { SubmissionStatusIdEnum } from '../enum/shared/submission-status-id.enum';
import { MemberSubmissionTypeEnum } from '../users/enum/member-submission-type-enum';

export class BlockingSubmission implements Deserializable {
  public id!: number;
  public typeId!: MemberSubmissionTypeEnum;
  public typeName!: string;
  public ownerId!: number;
  public statusId!: SubmissionStatusIdEnum;

  public onDeserialize(): void {}

  public isPendingVbConfigSubmission(): boolean {
    return (
      this.typeId === MemberSubmissionTypeEnum.VariableBenefitConfiguration &&
      this.statusId === SubmissionStatusIdEnum.Pending
    );
  }

  // Only its owner can re-enter a draft VB setup, so no one else gets a link to it
  public isLinkableFor(internalUserId: number | undefined): boolean {
    return !this.isPendingVbConfigSubmission() || this.ownerId === internalUserId;
  }

  public isApprovedVbConfigSubmission(): boolean {
    return (
      this.typeId === MemberSubmissionTypeEnum.VariableBenefitConfiguration &&
      this.statusId === SubmissionStatusIdEnum.Completed
    );
  }

  public isUnapprovedMonthlyPensionSetupSubmission(): boolean {
    return (
      this.typeId === MemberSubmissionTypeEnum.MonthlyPensionSetup &&
      [SubmissionStatusIdEnum.Pending, SubmissionStatusIdEnum.Submitted, SubmissionStatusIdEnum.InReview].contains(
        this.statusId
      )
    );
  }
}
